import { Injectable } from '@angular/core';
import { SortingParams } from 'src/app/interfaces/connections.interface';
import {
  CommentPosition,
  CommentView,
  FullRootCommentView,
  LoadedCommentsState,
} from 'src/app/interfaces/posts.interface';
import { CommentSortingStrategyService } from './comment-sorting-strategy.service';

@Injectable({ providedIn: 'root' })
export class DescendingCommentSortingStrategyService extends CommentSortingStrategyService {
  public getSortingParams(): SortingParams {
    return SortingParams.CreatedDesc;
  }

  public addNewRootComment(
    loadedComments: LoadedCommentsState,
    newRootComment: FullRootCommentView,
  ): LoadedCommentsState {
    const newLoadedCommentsState: LoadedCommentsState = structuredClone(loadedComments);

    newLoadedCommentsState.rootCommentFullViews = [newRootComment, ...newLoadedCommentsState.rootCommentFullViews];
    newLoadedCommentsState.rootCommentFullViews = this.sortRootComments(newLoadedCommentsState.rootCommentFullViews);

    newLoadedCommentsState.totalRootCommentsCount++;
    newLoadedCommentsState.loadedRootCommentsCount++;

    return newLoadedCommentsState;
  }

  public addNewReply(
    loadedComments: LoadedCommentsState,
    repliedCommentPosition: CommentPosition,
    replyCommentView: CommentView,
  ): LoadedCommentsState {
    const newLoadedCommentsState: LoadedCommentsState = structuredClone(loadedComments);

    const parentCommentView: FullRootCommentView =
      newLoadedCommentsState.rootCommentFullViews[repliedCommentPosition.indexRoot];

    parentCommentView.replyCommentViews = [replyCommentView, ...parentCommentView.replyCommentViews];
    parentCommentView.replyCommentViews = this.sortReplies(parentCommentView.replyCommentViews);

    parentCommentView.totalReplyCommentsCount++;
    parentCommentView.loadedReplyCommentsCount++;

    return newLoadedCommentsState;
  }

  protected sortingByDate(a: CommentView, b: CommentView): number {
    return new Date(b.source.creation_date).getTime() - new Date(a.source.creation_date).getTime();
  }
}
